import { RightOutlined } from "@ant-design/icons";
import { Card, Typography } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import type { LeaseEndUrgency } from "../utils/leaseEndUrgency";

const { Text } = Typography;

const URGENCY_STYLES: Record<
  LeaseEndUrgency,
  { iconBg: string; iconColor: string; descriptionColor: string }
> = {
  default: {
    iconBg: "rgba(24, 144, 255, 0.08)",
    iconColor: "#1677ff",
    descriptionColor: "rgba(0, 0, 0, 0.45)",
  },
  warning: {
    iconBg: "rgba(250, 173, 20, 0.12)",
    iconColor: "#d48806",
    descriptionColor: "#d48806",
  },
  danger: {
    iconBg: "rgba(255, 77, 79, 0.12)",
    iconColor: "#cf1322",
    descriptionColor: "#cf1322",
  },
};

export type HomeActionCardProps = {
  to: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  urgency?: LeaseEndUrgency;
};

export function HomeActionCard({
  to,
  icon,
  title,
  description,
  urgency = "default",
}: HomeActionCardProps) {
  const tone = URGENCY_STYLES[urgency];

  return (
    <Link to={to} style={{ display: "block", height: "100%", color: "inherit" }}>
      <Card
        hoverable
        styles={{
          body: {
            display: "flex",
            alignItems: "center",
            gap: 16,
            padding: "20px 24px",
            height: "100%",
          },
        }}
        style={{
          height: "100%",
          borderColor:
            urgency === "danger"
              ? "rgba(255, 77, 79, 0.35)"
              : urgency === "warning"
                ? "rgba(250, 173, 20, 0.45)"
                : undefined,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 44,
            height: 44,
            borderRadius: 10,
            background: tone.iconBg,
            color: tone.iconColor,
            fontSize: 20,
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Text strong style={{ display: "block", fontSize: 16 }}>
            {title}
          </Text>
          <Text style={{ fontSize: 13, color: tone.descriptionColor }}>
            {description}
          </Text>
        </div>
        <RightOutlined style={{ color: "rgba(0, 0, 0, 0.25)", flexShrink: 0 }} />
      </Card>
    </Link>
  );
}
